module.exports = __webpack_public_path__ + "static/img/bangzhu@2x.a22afb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/issue/bangzhu@2x.png
// module id = 26r8
// module chunks = 18